import { Container, Divider, Stack, Text, Title, Button, Group, Image } from '@mantine/core'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import SiteFooter from '../components/SiteFooter'
import { LOGO_URL, BRAND_NAME, BRAND_SUBLINE } from '../branding'
import { Seo, DEFAULT_OG_IMAGE } from '../components/Seo'

export const sections: Array<{ heading: string; paragraphs: string[] }> = [
  {
    heading: '1. Общие положения',
    paragraphs: [
      'Настоящие Условия использования (далее — «Условия») устанавливают порядок доступа к сервису Fravai и его использования (далее — «Сервис»), а также права и обязанности пользователей и Исполнителя.',
      'Регистрация или авторизация в Сервисе, оплата, загрузка изображений, запуск генерации либо иное использование Сервиса означает, что пользователь ознакомился с Условиями, понимает их содержание и безоговорочно принимает их.',
      'Сервис предназначен для пользователей старше 18 лет. Использование Сервиса лицами младше 18 лет допускается только с согласия законного представителя.'
    ]
  },
  {
    heading: '2. Регистрация и аккаунт',
    paragraphs: [
      'Доступ к Сервису осуществляется через доступные способы авторизации в интерфейсе Сервиса.',
      'Пользователь обязуется предоставлять актуальную и достоверную информацию, самостоятельно обеспечивать безопасность своего аккаунта и не передавать доступ третьим лицам. Пользователь несёт ответственность за все действия, совершённые с использованием его аккаунта.',
      'Загружая любые изображения, пользователь подтверждает, что обладает всеми необходимыми правами и правовыми основаниями для их использования, включая необходимые разрешения изображённых на фото лиц, и поручает Сервису обработать материалы исключительно для выполнения выбранных функций.'
    ]
  },
  {
    heading: '3. Услуги и платежи',
    paragraphs: [
      'Исполнитель оказывает цифровую услугу по предоставлению доступа к функциональности AI-генерации изображений.',
      'Доступ к отдельным функциям предоставляется при оплате пакетов токенов. Стоимость и состав пакетов указываются в интерфейсе Сервиса и могут изменяться Администрацией.',
      'Токены являются внутренней учётной единицей объёма доступа к Сервису, не являются денежными средствами, электронными деньгами, ценной бумагой и не подлежат обмену на деньги, продаже или передаче третьим лицам.',
      'После успешной оплаты Исполнитель формирует электронный чек в соответствии с законодательством о налоге на профессиональный доход. Если пользователь указал email при оплате, электронный чек направляется на указанный адрес электронной почты.'
    ]
  },
  {
    heading: '4. Возвраты',
    paragraphs: [
      'Возврат денежных средств возможен, если оплаченный доступ или генерация не были предоставлены по технической причине на стороне Сервиса.',
      'Если токены были начислены пользователю, доступ к соответствующему объёму функциональности считается предоставленным.',
      'Если пользователь использовал токены для запуска генерации, услуга в соответствующей части считается оказанной.',
      'Заявки на возврат рассматриваются через обращение на email поддержки. В обращении нужно указать email аккаунта, дату оплаты и описание проблемы.'
    ]
  },
  {
    heading: '5. Материалы пользователя и AI-обработка',
    paragraphs: [
      'Пользователь сохраняет все права на загружаемые материалы и результаты генерации, полученные с использованием Сервиса.',
      'Для работы Сервиса загруженные материалы могут обрабатываться и временно храниться в объеме, необходимом для генерации результатов, отображения истории генераций, технической поддержки и обеспечения работы Сервиса.',
      'Для выполнения отдельных функций Сервис может использовать внешние технические сервисы и AI-инструменты. В таких случаях материалы используются исключительно для обработки запросов пользователя и предоставления результата.',
      'Пользователь вправе обратиться в поддержку с запросом на удаление своих данных, если их дальнейшее хранение не требуется для обеспечения работы Сервиса или выполнения требований законодательства.'
    ]
  },
  {
    heading: '6. Ограничения использования',
    paragraphs: [
      'Пользователю запрещается использовать Сервис для создания, загрузки, распространения или иного оборота материалов, которые:',
      '— противоречат законодательству Российской Федерации; ',
      '— содержат насилие, материалы «18+», политическую или экстремистскую пропаганду; ',
      '— нарушают права третьих лиц, включая авторские и смежные права, права на товарные знаки, дизайн и иные объекты интеллектуальной собственности; ',
      '— направлены на злоупотребление возможностями Сервиса (абуз), использование технических ошибок или уязвимостей для обхода ограничений или получения необоснованных преимуществ.',
      'Пользователю также запрещается создавать изображения, которые могут воспроизводить, имитировать или иные индивидуальные признаки известных физических лиц (включая публичных персон, актёров, политиков, блогеров и иных узнаваемых лиц) без их предварительного согласия.'
    ]
  },
  {
    heading: '7. Ответственность',
    paragraphs: [
      'Сервис предоставляется по принципу «как есть» («as is»), без каких-либо явных или подразумеваемых гарантий работоспособности, пригодности для определённых целей, непрерывности и безошибочности.',
      'Результаты AI-генерации создаются автоматически и могут содержать ошибки, искажения, сходство с реальными объектами, лицами или стилями. Администрация не гарантирует 100% качество, точность или соответствие ожиданиям пользователей.',
      'Пользователь самостоятельно оценивает возможность использования результата и несёт ответственность за его дальнейшее применение, включая соблюдение законодательства, прав третьих лиц, правил площадок публикации и требований к маркировке контента.',
      'Администрация не несёт ответственности за любой прямой или косвенный ущерб, упущенную выгоду, потерю данных, репутационные или иные потери, возникшие в связи с использованием либо невозможностью использования Сервиса, за исключением случаев, прямо предусмотренных законодательством.',
      'В случае предъявления претензий к Администрации Сервиса со стороны третьих лиц, связанных с действиями пользователя, пользователь обязуется самостоятельно урегулировать такие претензии и возместить документально подтверждённые убытки Администрации.'
    ]
  },
  {
    heading: '8. Права администрации',
    paragraphs: [
      'Администрация вправе по своему усмотрению изменять, дополнять или ограничивать функционал Сервиса, а также пересматривать цены и условия предоставления платных функций без предварительного уведомления.',
      'При нарушении пользователем настоящих Условий Администрация вправе удалить контент, ограничить доступ к результатам генерации, заблокировать аккаунт и отказать в дальнейшем оказании услуг.',
      'Администрация вправе передавать компетентным органам информацию о пользователях и их действиях в случаях, предусмотренных законодательством Российской Федерации.'
    ]
  },
  {
    heading: '9. Заключительные положения',
    paragraphs: [
      'Администрация вправе периодически обновлять настоящие Условия. Актуальная редакция публикуется в Сервисе и применяется с момента размещения.',
      'К отношениям сторон применяется право Российской Федерации. Продолжение использования Сервиса после внесения изменений означает согласие пользователя с обновлённой редакцией Условий.'
    ]
  }
]



export default function TermsPage() {
  return (
    <>
     <Seo
       title="Пользовательское соглашение"
       description="Условия использования сервиса Fravai."
       canonical="/legal/terms"
       robots="noindex, follow"
     />
      <Container size="md" py="xl">
        <div style={{ position: 'sticky', top: 0, zIndex: 50, backdropFilter: 'saturate(1.2) blur(6px)', borderBottom: '1px solid var(--border, #e5e7eb)', background: 'rgba(255,255,255,.8)' }}>
          <Container size="lg" py="sm">
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <Group gap="xs" align="center">
                <Image src={LOGO_URL} alt={`${BRAND_NAME} logo`} w={28} h={28} fit="contain" style={{ display: 'block' }} />
                <div className="brand-lockup">
                  <span className="brand-wordmark">{BRAND_NAME}</span>
                </div>
              </Group>
            </Link>
          </Container>
        </div>
        <Stack gap="lg" style={{ marginTop: 32 }}>
          <Stack gap="xs">
            <Title order={2}>Условия использования</Title>
          </Stack>

          {sections.map((section) => (
            <Stack key={section.heading} gap="sm">
              <Title order={4}>{section.heading}</Title>
              {section.paragraphs.map((text, idx) => (
                <Text key={idx} c="dimmed">
                  {text}
                </Text>
              ))}
              <Divider mt="sm" />
            </Stack>
          ))}

          <Stack gap="xs">
            <Title order={4}>Контакты</Title>
            <Text c="dimmed">
              По всем вопросам использования сервиса пишите в TG @fravai_support_bot или на почту support@fravai.com  — мы ответим и постараемся помочь.
            </Text>
            <Text c="dimmed">
              Исполнитель: Мухтaровa Мaккa Хaнпашaевнa, ИНН 054409764981, плательщик налога на профессиональный доход.
            </Text>
          </Stack>
        </Stack>
      </Container>
    </>
  )
}
